import { render } from "./AllOrderStatus.vue?vue&type=template&id=c10181a2&scoped=true"
import script from "./AllOrderStatus.vue?vue&type=script&lang=js"
export * from "./AllOrderStatus.vue?vue&type=script&lang=js"

import "./AllOrderStatus.vue?vue&type=style&index=0&id=c10181a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c10181a2"]])

export default __exports__